export default {
  translation: {
    common: {
      emailOrUsername: 'E-Mail-Adresse oder Benutzername',
      invalidUsernameOrPassword: 'Ungültige Benutzername oder Passwort',
      logInToBoards: 'Einloggen',
      noInternetConnection: 'Keine Internetverbindung',
      pageNotFound_title: 'Seite nicht gefunden',
      password: 'Passwort',
      serverConnectionFailed: 'Serververbindung fehlgeschlagen',
      unknownError: 'Unbekannter Fehler, bitte später erneut versuchen',
    },

    action: {
      logIn: 'Einloggen',
    },
  },
};
